import { Flex, Box } from '@blockanalitica/ui';
import { NavLink as RouterNavLink } from 'react-router';
import styled, { css } from 'styled-components';
import { NavigationRoute } from './Navigation';

export const StyledIcon = styled(Flex)`
  color: ${({ theme }) => theme.colors.hype.background70};
`;

const NavDropdownMenuWrapper = styled(Flex)`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  width: fit-content;
  z-index: 101;
  left: 50%;
  transform: translateX(-50%);

  ${({ theme }) => css`
    padding-top: ${theme.space['2xs']};
  `}
`;

const NavDropdownMenu = styled(Flex)`
  flex-direction: column;

  ${({ theme }) => css`
    border-radius: ${theme.space['3xs']};
    background: ${theme.colors.primary};
    padding: ${theme.space['2xs']} 0;
  `}
`;

const NavDropdownWrapper = styled(Box)`
  position: relative;
  &:hover ${NavDropdownMenuWrapper} {
    opacity: 1;
    visibility: visible;
  }
`;

const NavDropdownButton = styled(Flex)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: default;
  font-weight: 700;

  ${({ theme }) => css`
    gap: ${theme.space['2xs']};
    color: ${theme.colors.primary};
    font-size: ${theme.sizes['0']};

    &:hover {
      color: ${theme.colors.hype.textPrimaryHover};
    }
  `}
`;

const NavDropdownItem = styled(RouterNavLink)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-weight: 600;

  ${({ theme }) => css`
    gap: ${theme.space['2xs']};
    color: ${theme.colors.hype.background70};
    font-size: ${theme.sizes['0']};
    padding: ${theme.space['2xs']} ${theme.space['s']};

    &:hover,
    &:hover ${StyledIcon} {
      color: ${theme.colors.hype.background70};
      background: ${theme.colors.hype.textPrimaryHover};
    }
  `}
`;

export default function NavDropdown({ route }: { route: NavigationRoute }) {
  if (!route.subRoutes || route.subRoutes.length === 0) {
    return null;
  }

  return (
    <NavDropdownWrapper>
      <NavDropdownButton>{route.title}</NavDropdownButton>
      <NavDropdownMenuWrapper>
        <NavDropdownMenu>
          {route.subRoutes.map((subRoute) => (
            <NavDropdownItem
              key={subRoute.linkTo}
              to={subRoute.linkTo}
              end={subRoute.end}>
              <StyledIcon>{subRoute.icon}</StyledIcon>
              {subRoute.title}
            </NavDropdownItem>
          ))}
        </NavDropdownMenu>
      </NavDropdownMenuWrapper>
    </NavDropdownWrapper>
  );
}
